import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { RouterProvider } from "react-router-dom"
import { router } from "@/app/router"
import { bootstrapObservability } from "@/lib/observability/bootstrap"
import { syncFaviconWithTheme } from "@/lib/ui/favicon"
import "./index.css"

// Sync favicon with persisted theme before first paint
syncFaviconWithTheme()

// Stale-chunk recovery: after a deploy, a browser still holding the previous
// bundle's hashed import paths (e.g. companyReport-n8Z0Flv8.js) gets 404s on
// dynamic import. Hard-reload once when that surfaces so the new bundle
// loads. Sentry HPS-FRONTEND-3.
const CHUNK_RELOAD_KEY = "hps_chunk_reloaded_at"
function isChunkLoadError(message: string | undefined): boolean {
  if (!message) return false
  return /Failed to fetch dynamically imported module|Importing a module script failed|ChunkLoadError|Loading chunk \d+ failed/i.test(message)
}
function reloadOnce(): void {
  const last = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) ?? "0")
  if (Date.now() - last < 30_000) return // already tried in the last 30s
  sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()))
  window.location.reload()
}
window.addEventListener("error", (e) => {
  if (isChunkLoadError(e?.message)) reloadOnce()
})
window.addEventListener("unhandledrejection", (e) => {
  const m = (e?.reason as { message?: string })?.message
  if (isChunkLoadError(m)) reloadOnce()
})

// Initialize observability before rendering
bootstrapObservability().then(() => {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>
  )
})
